<div [ngClass]="{ 'hide-add-company': hideAddCompany() }" class="dropdown-container" [@fillIn]="'in'">
  @if (filteredContractors()?.invitedContractors.length || filteredContractors()?.temporaryContractors?.length) {
    <ng-scrollbar class="std-scrollbar" appearance="native">
      @for (contractor of filteredContractors()?.invitedContractors; track contractor) {
        <span class="cursor-pointer">
          <span (click)="selectOption(contractor, false)" class="flex text-navy-700 text-size_l font-bold p-2">{{
            contractor.company_name
          }}</span>
          <span class="border-bottom"></span>
        </span>
      }
      @for (
        temporaryContractor of filteredContractors()?.temporaryContractors;
        track temporaryContractor;
        let last = $last
      ) {
        <span class="cursor-pointer">
          <span (click)="selectOption(temporaryContractor, true)" class="flex p-2">
            <span class="text-navy-700 text-size_l font-bold">{{ temporaryContractor.company_name }}</span>
            <app-temporary-contractor-icon></app-temporary-contractor-icon>
          </span>
          <span [ngClass]="{ '!hidden': last && hideAddCompany() }" class="border-bottom"></span>
        </span>
      }
    </ng-scrollbar>
  }
  @if (!filteredContractors()?.invitedContractors.length && !filteredContractors()?.temporaryContractors?.length) {
    <span class="flex flex-1 font-bold text-size_l pt-2 px-2 pb-0.5">No companies found</span>
  }
  @if (!hideAddCompany()) {
    <span (click)="switchDropdown()" class="text-blue-700 font-bold pointer-cursor text-size_l pt-2 px-2 pb-0.5"
      >Add Company
    </span>
  }
</div>
